export const sheepYellow = '#fdffb1';
export const pageBackground = 'black';
export const agGreen = '#17a737';
export const rowColorA = '#747474';
export const rowColorB = '#4d4d4d';
export const viewColor = '#4682B4';
export const deleteColor = '#C11400';
export const backColor = '#3399FF';
export const applyTan = '#9e9e8d';